import { WHATSAPP_URL } from "../lib/site";
import { FadeUp, MaskedLine } from "./Reveal";

const STEPS = [
    {
        n: "01",
        title: "Message us",
        text: "Send photos of your current bathroom on WhatsApp. We reply with first thoughts.",
    },
    {
        n: "02",
        title: "Design visit",
        text: "We visit, measure, and understand how you bathe, store, and get ready.",
    },
    {
        n: "03",
        title: "Design & quote",
        text: "A clear design and a fixed quote \u2014 tiles, fittings, lighting, everything in one plan.",
    },
    {
        n: "04",
        title: "Turnkey renovation",
        text: "One team executes end to end \u2014 civil, plumbing, electrical, fittings \u2014 and hands over a finished sanctuary.",
    },
];

const Process = () => (
    <section className="bg-mineral text-ink" data-testid="process-section">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-10 py-16 sm:py-24">
            <div className="mb-14 sm:mb-20 max-w-2xl">
                <FadeUp>
                    <p className="font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-sand mb-6">
                        How it works
                    </p>
                </FadeUp>
                <h2 className="font-serif font-light leading-[1.05] tracking-tight text-[clamp(2.2rem,4.5vw,4rem)]">
                    <MaskedLine>Four steps between</MaskedLine>
                    <MaskedLine delay={0.1}>
                        you and a <em className="italic">better</em> morning.
                    </MaskedLine>
                </h2>
            </div>

            <div className="grid gap-px bg-ink/10 sm:grid-cols-2 lg:grid-cols-4 border hairline-light">
                {STEPS.map((s, i) => (
                    <FadeUp key={s.n} delay={i * 0.08} className="bg-mineral">
                        <div
                            className="group h-full p-8 sm:p-10 transition-colors duration-500 hover:bg-white"
                            data-testid={`process-step-${s.n}`}
                        >
                            <p className="font-mono text-xs text-sand mb-10 sm:mb-16">{s.n}</p>
                            <h3 className="font-serif text-2xl mb-3">{s.title}</h3>
                            <p className="text-sm font-light leading-relaxed text-ink/65">{s.text}</p>
                        </div>
                    </FadeUp>
                ))}
            </div>

            <FadeUp delay={0.2}>
                <div className="mt-12 flex flex-col items-center gap-3 sm:items-start">
                    <a
                        data-testid="process-whatsapp-cta"
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="rounded-full border border-ink px-8 py-4 text-sm font-semibold text-ink transition-all duration-300 hover:bg-ink hover:text-white"
                    >
                        Start with step one &mdash; WhatsApp us
                    </a>
                    <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-ink/40">
                        A Spaces by Samita venture &mdash; now renovating across Bangalore
                    </p>
                </div>
            </FadeUp>
        </div>
    </section>
);

export default Process;
